<template>
  <div class="mc-delivery-track-expired-wrapper">
    <div class="mc-delivery-track-expired-content">
      <img class="mc-delivery-track-expired-image" :src="expiredIlustration" alt="expired" />

      <h3 class="mc-delivery-track-expired-title">
        {{ 'Batas Aktif Tautan Pelacakan Sudah Habis' }}
      </h3>

      <p class="mc-delivery-track-expired-desc">
        {{ 'Terima kasih telah menggunakan jasa kami' }}
      </p>
    </div>
  </div>
</template>

<script>
import expiredIlustration from '@/assets/images/expired.png'
export default {
  name: 'TrackingExpired',
  data() {
    return {
      expiredIlustration,
    }
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-track-expired-wrapper {
  width: 100%;
  height: 100vh;
  background: #f8fbff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mc-delivery-track-expired-content {
  text-align: center;
  max-width: 500px;
  padding: 20px;
}

.mc-delivery-track-expired-image {
  width: 220px;
  margin-bottom: 20px;
}

.mc-delivery-track-expired-title {
  font-size: 18px;
  font-weight: 600;
  color: $teal-400;
  margin-bottom: 6px;
}

.mc-delivery-track-expired-desc {
  font-size: 14px;
  color: $teal-300;
}
</style>
